module.exports = "/packs/008-52aa7492d1aa5414b65f7b896b53ab9f.svg";